import React from 'react';

/** Large cover + avatar hero for LinkedIn-style staff profile. */
export default function StaffProfileHero({ user, roleLabel, accent, onEdit }) {
  const initial = (user?.name || user?.email || '?')[0].toUpperCase();
  return (
    <div className="relative" data-testid="staff-profile-hero">
      <div
        className="h-28 sm:h-36"
        style={{
          background: `linear-gradient(120deg, #040E1A 0%, #071B34 45%, ${accent} 160%)`,
        }}
      />
      <div className="px-6 pb-4">
        <div className="flex flex-col sm:flex-row sm:items-end gap-4 -mt-12 sm:-mt-14">
          <div className="h-28 w-28 sm:h-32 sm:w-32 rounded-full border-4 border-white shadow-lg overflow-hidden bg-[#E8EEF5] shrink-0">
            {user?.photo_url ? (
              <img src={user.photo_url} alt="" className="h-full w-full object-cover" />
            ) : (
              <div className="h-full w-full grid place-items-center text-3xl font-bold text-[#071B34] font-heading">
                {initial}
              </div>
            )}
          </div>
          <div className="flex-1 min-w-0 pb-1">
            <h2 className="text-2xl font-semibold text-zinc-900 font-heading leading-tight truncate">
              {user?.name || 'Staff member'}
            </h2>
            {user?.title ? <p className="text-sm text-zinc-600 mt-0.5">{user.title}</p> : null}
            <p className="text-sm font-medium mt-1" style={{ color: accent }}>
              {[
                (user?.designations || []).find((d) => d.is_current)?.title || user?.designation,
                user?.specialization,
                roleLabel,
              ].filter(Boolean).join(' · ') || 'Hospital staff'}
            </p>
            {user?.category ? (
              <p className="text-xs text-zinc-500 mt-1">{user.category}</p>
            ) : null}
          </div>
          {onEdit ? (
            <button
              type="button"
              onClick={onEdit}
              className="self-start sm:self-end px-4 py-2 rounded-full text-sm font-semibold text-white"
              style={{ background: accent }}
              data-testid="staff-profile-edit-cta"
            >
              Edit profile
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
